import { CardGrid } from '../cardGrid/cardGrid';
import type { CardGridProps } from '../cardGrid/cardGrid';

export const SpecialsGrid = ({ children, ...props }: CardGridProps) => {
  return (
    <CardGrid minCardWidth={260} {...props}>
      {children}
    </CardGrid>
  );
};
